import React, { createContext, useCallback, useContext, useState } from 'react';
import AACChromeAPI from '@amzn/aac-chrome-api';
import { useChromeConfigurationListenerWithCallback } from 'src/commons/hooks';
import { ChromeConfigurationChangeEvent } from 'src/commons/types';
import { ChromeConfig, PAGE_LAYOUT_TYPE } from 'src/app/slice';

export const ChromeConfigContext = createContext<ChromeConfig>({
  breadcrumbs: [],
  pageTitleBreadcrumb: {
    label: '',
  },
  marketplaceSwitcher: {
    useMarketplaceSwitcher: true,
    marketplacePath: '',
  },
  regionSwitcherEnabled: false,
  currencyVisualisation: {
    useCurrencyVisualisation: false,
  },
  mobileWebSupport: '',
  nestedPivotNav: {
    menuItemGroups: [],
    selectedItemId: '',
    isCollapsable: false,
  },
  pivotNav: {
    items: [],
    selectedItemId: '',
  },
  pageId: '',
  pageLayoutType: PAGE_LAYOUT_TYPE.STANDARD,
  pageHeader: {
    pageName: '',
  },
  isGlobal: false,
  isAggregated: false,
  appName: '',
});

export const ChromeConfigContextProvider: React.FC = ({ children }) => {
  const [chromeConfig, setChromeConfig] = useState(
    AACChromeAPI.getChromeConfiguration() as unknown as ChromeConfig,
  );
  const callback = useCallback((event: ChromeConfigurationChangeEvent) => {
    const newConfig = event.detail.chromeConfiguration;
    setChromeConfig(newConfig as any);
  }, []);

  useChromeConfigurationListenerWithCallback(callback);
  return (
    <ChromeConfigContext.Provider value={chromeConfig}>
      {children}
    </ChromeConfigContext.Provider>
  );
};

export const useChromeConfigContext = (): ChromeConfig => {
  const context = useContext(ChromeConfigContext);
  if (context === undefined) {
    throw new Error(
      'useChromeConfigContext must be used within a ChromeConfigContextProvider',
    );
  }
  return context;
};
